import {
  RiskToleranceService,
  RiskToleranceServiceOptions,
  // request
  RTQHistoryOptions,
  QuestionnaireByRiaOptions,
  // response
  RTQHistoryResponse,
  RiaQuestionnaireResponse,
} from '@digital-advice/ms-rtq-sdk';
import {apiKey, getLogger, endpoint, interceptors, sourceInfo} from '@advisor/services/sdk';

export const defaultOptions: RiskToleranceServiceOptions = {
  logger: getLogger(),
  apiKey,
  endpoint,
  interceptors,
  sourceInfo,
};

export default class RiskToleranceQuestionnaireServices {
  static async sdkService(options: RiskToleranceServiceOptions = defaultOptions): Promise<RiskToleranceService> {
    const service = await new RiskToleranceService(options);

    return service;
  }

  /**
   * Gateway endpoint:getRTQQuestionnaireHistory
   */

  static async getRTQQuestionnaireHistory(payload: RTQHistoryOptions): Promise<RTQHistoryResponse> {
    const service = await this.sdkService(defaultOptions);

    return service.getRTQQuestionnaireHistory(payload);
  }
  /**
   * Gateway endpoint:getQuestionnaireByRia
   */

  static async getQuestionnaireByRia(payload: QuestionnaireByRiaOptions): Promise<RiaQuestionnaireResponse> {
    const service = await this.sdkService(defaultOptions);

    return service.getQuestionnaireByRia(payload);
  }
  /**
   * Gateway endpoint:postQuestionnaireByRia
   */

  static async postQuestionnaireByRia(payload: QuestionnaireByRiaOptions): Promise<RiaQuestionnaireResponse> {
    const service = await this.sdkService(defaultOptions);

    return service.postQuestionnaireByRia(payload);
  }
  /**
   * Gateway endpoint:postRestoreQuestionnaire
   */

  static async postRestoreQuestionnaire(payload: QuestionnaireByRiaOptions): Promise<RiaQuestionnaireResponse> {
    const service = await this.sdkService(defaultOptions);

    return service.postRestoreQuestionnaire(payload);
  }
}
